import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup, FormGroupDirective } from '@angular/forms';
import { DateService } from 'src/app/shared/services/date.service';
import { GetOpenEnrollmentRule } from '../../../../family-form/types/qualifying-life-event.response.interface';
import { LifeEventCustomAttributes } from '../../interfaces/special-enrollment-qualification-page-proxy.interface';
import { FamilyFormService } from '../../../../family-form/services/family-form.service';
import { setSelectedLifeEventId, setFetchFormConfig } from 'src/app/shared/reducers/sep-life-event-form.reducer';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { SepLifeEventService } from 'src/app/shared/services/sep-life-event.service';

interface ComponentFormControls {
  lifeEvent: AbstractControl;
}

@Component({
    selector: 'app-life-event-single-page-proxy-form',
    templateUrl: './life-event-single-page-proxy-form.component.html',
    styleUrls: ['./life-event-single-page-proxy-form.component.scss'],
    standalone: false,
    //this allows us detect the form being used as a wrapper for this component in the parent component 
    viewProviders: [ 
      { 
        provide: ControlContainer,
        useExisting: FormGroupDirective
      } 
    ]
})
export class LifeEventSinglePageProxyFormComponent implements OnInit {

  @Input() componentDisplayAttributes: LifeEventCustomAttributes;

  @ViewChild('lifeEventSelect') lifeEventSelect: any;

  eventForm: FormGroup;
  qualifyingLifeEvents: any;
  availableLifeEvents: string[] = [];
  loadingOptions = false;

  constructor(
    private formGroupDirective: FormGroupDirective,
    private dateService: DateService,
    private familyFormService: FamilyFormService,
    private ngRedux: NgRedux<StateStructure>,
    private sepLifeEventService: SepLifeEventService
  ) {}
  async ngOnInit(): Promise<void> {
    
    //connect the parent form
    this.eventForm = this.formGroupDirective.form;
    this.setupOptions();
  }

  get eventFormControls(): ComponentFormControls{
    return this.eventForm?.controls as unknown as ComponentFormControls;
  }

  eventChanged(type: any, event: any){
    this.eventForm.controls[this.componentDisplayAttributes.formControlAttributes.formControlName].updateValueAndValidity();
  }

  /** Necessary to have VIEW reflect PROGRAMMATIC setting of values */
  compareWithFn(obj1: GetOpenEnrollmentRule, obj2: GetOpenEnrollmentRule) {
    return obj1 && obj2 && obj1.lifeEventId === obj2.lifeEventId;
  }

  private toggleSpinner() {
    this.loadingOptions = !this.loadingOptions;
  }

  async setupOptions() {
    if (this.componentDisplayAttributes?.custom?.fetchFromConfig) {
      this.qualifyingLifeEvents
        = (this.componentDisplayAttributes?.custom?.qualifyingLifeEvents as GetOpenEnrollmentRule[]).map(event => {
          event.asOfDate = this.dateService.getTodayAsMoment();
          return event;
        });
    } else {
      /** Get qualifying life event options */
      this.toggleSpinner();
      const response = await this.familyFormService.getOpenEnrollmentRules(null);
      this.toggleSpinner();
      this.qualifyingLifeEvents
        = (response.responseData.dataElement.getOpenEnrollmentRules as GetOpenEnrollmentRule[]).map(event => {
          event.asOfDate = this.dateService.getTodayAsMoment();
          return event;
        });
    }

    this.ngRedux.dispatch(setFetchFormConfig(this.componentDisplayAttributes.custom.fetchFromConfig ?? true));
  }

  onLifeEventSelected(lifeEventId: string): void {
    // Store in Redux
    this.ngRedux.dispatch(setSelectedLifeEventId(lifeEventId));
    
    // Store in Redux
    this.sepLifeEventService.findLifeEventRule(this.qualifyingLifeEvents, lifeEventId);
  }

  get fieldWidth(){
    if(this.componentDisplayAttributes?.custom?.minFieldWidth && this.componentDisplayAttributes?.custom?.maxFieldWidth){
      return `clamp(${this.componentDisplayAttributes?.custom?.minFieldWidth}, 35vw, ${this.componentDisplayAttributes?.custom?.maxFieldWidth})`
    } 
    return;
  }

}
